const Alert = (props) => {
  return (
    <p className="alert--hero">
        {props.error}
    </p>
  )
}

export default Alert